import { useCallback, useMemo, useState } from "react";

const getListHints = ({ hints = [], values = [] }) => {
  const { listHints, unusedHints } = values.reduce(
    (acc, value, index) => {
      const valueIsHint = hints.some((h) => h === value);
      const [nextHint, ...unused] = acc.unusedHints;

      if (valueIsHint || !nextHint || value) {
        return {
          listHints: acc.listHints.concat(""),
          unusedHints: acc.unusedHints,
        };
      }

      return {
        listHints: acc.listHints.concat(nextHint),
        unusedHints: unused,
      };
    },
    {
      listHints: [],
      unusedHints: hints.filter((h) => !values.some((v) => v === h)),
    },
  );
  return { listHints, unusedHints };
};

const emptyArr = [];

export const useListHints = ({ hints = emptyArr, values = emptyArr }) => {
  const [hintsShift, setHintsShift] = useState(0);
  const shiftedHints = useMemo(() => {
    const shifted = hints
      .slice(hintsShift % hints.length, hints.length)
      .concat(hints.slice(0, hintsShift))
      .slice(0, hints.length);
    return shifted;
  }, [hints, hintsShift]);

  const { listHints, unusedHints } = useMemo(
    () => getListHints({ hints: shiftedHints, values }),
    [values, shiftedHints],
  );
  const getHintAt = (index) => listHints[index] || "";
  const handleRefresh = useCallback(() => {
    setHintsShift((i) => i + 1);
  }, [setHintsShift]);
  const handleRefreshMaybe = unusedHints.length ? handleRefresh : undefined;

  return { getHintAt, handleRefreshMaybe };
};
